import styled from 'styled-components';

export const SwitchGroupLabelContainer = styled.div`
    padding-top: 2px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
`;

export const SwitchGroupCaption = styled.span`
    display: inline-block;
    font-size: 12px;
    line-height: 16px;
    color: rgba(68, 90, 100, 1);
`;
